import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Card } from 'react-bootstrap';
import { Crud_Catalogos } from "../herramientas/Crud_Catalogos";

const VisualizadorArchivos = ({ show, onHide, conf, fecha, nombre }) => {
    const [archivos, setArchivos] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show && conf && fecha && nombre) {
            buscarArchivos();
        }
    }, [show, conf, fecha, nombre]);

    const buscarArchivos = async () => {
        setLoading(true);
        try {
            const response = await Crud_Catalogos(
                `plataforma_evidencia_archivo/buscar-archivos?conf=${conf}&fecha=${fecha}&nombre=${nombre}`,
                "plataforma_evidencia_archivo",
                "get",
                ""
            );
            setArchivos(response || {});
        } catch (error) {
            console.error("Error buscando archivos:", error);
            setArchivos({});
        }
        setLoading(false);
    };

    const isImage = (filename) => {
        return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
    };

    const createFileUrl = (filename, data) => {
        if (typeof data === 'string') {
            // Si data es un string base64, convertirlo a data URL
            const mimeType = isImage(filename) ? `image/${filename.split('.').pop().toLowerCase()}` : 'application/octet-stream';
            return `data:${mimeType};base64,${data}`;
        } else {
            // Si data es un array de bytes
            const byteArray = new Uint8Array(data);
            const blob = new Blob([byteArray]);
            return URL.createObjectURL(blob);
        }
    };

    const downloadFile = (filename, data) => {
        let url;
        if (typeof data === 'string') {
            // Si data es un string base64, convertirlo a data URL
            const mimeType = isImage(filename) ? `image/${filename.split('.').pop().toLowerCase()}` : 'application/octet-stream';
            url = `data:${mimeType};base64,${data}`;
        } else {
            // Si data es un array de bytes
            url = createFileUrl(filename, data);
        }
        
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        
        if (typeof data !== 'string') {
            URL.revokeObjectURL(url);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Archivos - {nombre}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {loading ? (
                    <div className="text-center p-4">Cargando archivos...</div>
                ) : Object.keys(archivos).length === 0 ? (
                    <div className="text-center p-4 text-muted">No se encontraron archivos</div>
                ) : (
                    <Row>
                        {Object.entries(archivos).map(([filename, data]) => (
                            <Col md={6} lg={4} key={filename} className="mb-3">
                                <Card className="h-100">
                                    <Card.Body className="p-2">
                                        {isImage(filename) ? (
                                            <img
                                                src={createFileUrl(filename, data)}
                                                alt={filename}
                                                className="img-fluid rounded mb-2"
                                                style={{ maxHeight: '150px', width: '100%', objectFit: 'cover' }}
                                            />
                                        ) : (
                                            <div className="text-center p-3 bg-light rounded mb-2">
                                                <i className="fa fa-file fa-3x text-muted"></i>
                                            </div>
                                        )}
                                        <div className="text-truncate small mb-2" title={filename}>
                                            {filename}
                                        </div>
                                        <Button
                                            size="sm"
                                            variant="outline-primary"
                                            onClick={() => downloadFile(filename, data)}
                                            className="w-100"
                                        >
                                            <i className="fa fa-download me-1"></i>
                                            Descargar
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default VisualizadorArchivos;
